import React, { useEffect, useState } from "react";
import AnalData from "./AnalData";
import AnalSenti from "./AnalSenti";
import { useHistory } from "react-router-dom";
import axios from "axios";

const AnalyzeTool = ({ memo, updated, isIndex }) => {
  const [audio, setAudio] = useState();
  useEffect(() => {
    const getAud = async () => {
      let url = "http://203.185.132.220:9980/tts";
      let params = {
        name: "blue",
        key: "1234567890",
        text: memo,
        speed: 0,
      };
      let resJson = await axios.post(url, params);
      setAudio(resJson.data.result);
    };
    getAud();
  }, [memo]);
  const history = useHistory();
  return (
    <div className={`${isIndex ? "mt-2" : ""}`}>
      {audio && (
        <audio controls className={`w-full h-12 ${isIndex ? "mb-2" : "mb-4"}`}>
          <source src={audio} type="audio/mpeg" />
        </audio>
      )}
      <AnalSenti memo={memo} isIndex={isIndex} />
      <AnalData memo={memo} updated={updated} isIndex={isIndex} />
      <div
        className="text-xl text-gray-500 flex justify-end mt-3 items-center cursor-pointer w-full"
        onClick={() => history.push("/")}
      >
        <svg
          className="w-6 h-6"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
            clipRule="evenodd"
          />
        </svg>
        <p className="p-0 m-0 ml-3">Back</p>
      </div>
    </div>
  );
};

export default AnalyzeTool;
